import { render, staticRenderFns } from "./SupportDialog.vue?vue&type=template&id=4a30b9b7&"
import script from "./SupportDialog.vue?vue&type=script&lang=ts&"
export * from "./SupportDialog.vue?vue&type=script&lang=ts&"
import style0 from "./SupportDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VDialog,VIcon,VSelect,VTextField,VTextarea})
